import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    BooleanInput,
    SelectInput,
    ReferenceInput,
    AutocompleteInput,
    TopToolbar,
    SaveButton,
    Toolbar,
    required,
    useTranslate,
} from 'react-admin';
import { Link } from 'react-router-dom';
import { Grid, Button, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoSchemaForm from '../../components/InfoSchemaForm';

const CreateActions = () => {
    const translate = useTranslate();
    return (
        <TopToolbar>
            <Button
                startIcon={<ArrowBackIcon />}
                component={Link}
                to="/hallinta?tab=6"
                size="small"
            >
                {translate('hallinta.api_configs.actions.back')}
            </Button>
        </TopToolbar>
    );
};

const CreateToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

const ApiConfigCreate = () => {
    const translate = useTranslate();

    return (
        <Create
            resource="admin/api-configs"
            redirect="edit"
            actions={<CreateActions />}
        >
            <SimpleForm toolbar={<CreateToolbar />}>
                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 5 }}>
                        <Typography variant="h6" gutterBottom>
                            {translate('hallinta.api_configs.sections.basic')}
                        </Typography>
                        <ReferenceInput
                            source="application_guid"
                            reference="application"
                        >
                            <AutocompleteInput
                                optionText="name"
                                validate={required()}
                                label={translate(
                                    'hallinta.api_configs.fields.application_name'
                                )}
                                fullWidth
                            />
                        </ReferenceInput>
                        <TextInput
                            source="key"
                            label={translate('hallinta.api_configs.fields.key')}
                            validate={required()}
                            fullWidth
                        />
                        <TextInput
                            source="name"
                            label={translate(
                                'hallinta.api_configs.fields.name'
                            )}
                            fullWidth
                        />
                        <BooleanInput
                            source="is_default"
                            label={translate(
                                'hallinta.api_configs.fields.is_default'
                            )}
                        />
                        <SelectInput
                            source="type"
                            label={translate(
                                'hallinta.api_configs.fields.type'
                            )}
                            choices={[{ id: 'openid', name: 'OpenID' }]}
                            defaultValue="openid"
                            fullWidth
                        />
                    </Grid>
                    <Grid size={{ xs: 12, md: 7 }}>
                        <Typography variant="h6" gutterBottom>
                            {translate(
                                'hallinta.api_configs.sections.json_config'
                            )}
                        </Typography>
                        <InfoSchemaForm
                            resource="api-config"
                            type="openid"
                            source="info"
                        />
                    </Grid>
                </Grid>
            </SimpleForm>
        </Create>
    );
};

export default ApiConfigCreate;
